import React, { useState, useCallback, useEffect, useRef } from "react";
import Head from "next/head";
import Toggle from "../../../utils/Toggle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faSpinner } from "@fortawesome/free-solid-svg-icons";
import vinyl from "../../../images/vinyl.webp";
import { useCurrentPlayingContext } from "../../../utils/CurrentStationContextWrapper";
import styles from "../../../styles/Home.module.css";
import LazyLoadImage from "../../../utils/lazyLoadImage";
import Footer from "../../../utils/footer";
import fs from "fs";
import path from "path";
import zlib from "zlib";
import {
  getCountryListInAlphabeticalOrderWithIso1,
  getCountryListForOtherStations1,
} from "../../../utils/apiFunctions";
import Link from "next/link";

const StationByCountryName = ({
  countryname,
  countryformation,
  countryFlag,
}) => {
  const imageRefs = useRef([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [loadMore, setLoadMore] = useState("");
  const [paginate, setPaginate] = useState(20);
  const [paginateQuery, setPaginateQuery] = useState(20);
  const [divToView, setDivToView] = useState("");
  const [query, setQuery] = useState("");
  const [searchedResult, setSearchedResult] = useState();

  const { addToRecentStions } = Toggle();

  const { currentStation, setCurrentStation } = useCurrentPlayingContext();

  //== Loading card ==
  const LoadingDataPlaceHolder = () => (
    <div className="allradios-wrapper">
      <div className="index-menu__wrapper" style={{ minHeight: "40px" }}>
        <div className="index-menu__item" style={{ filter: "blur(6px)" }}>
          #########
        </div>
        <div className="index-menu__item" style={{ filter: "blur(6px)" }}>
          #########
        </div>
        <div className="index-menu__item" style={{ filter: "blur(6px)" }}>
          #########
        </div>
      </div>
    </div>
  );

  //= Search function for radio station in specific country =
  const searchfilterforradiostaion = (e) => {
    const keyword = e.target.value;
    setIsLoading(true);
    if (keyword !== "" && countryformation?.length) {
      const results = countryformation?.filter(
        (data) =>
          data?.name.toLowerCase().includes(keyword.toLowerCase()) ||
          data?.language.toLowerCase().includes(keyword.toLowerCase()) ||
          data?.tags.toLowerCase().includes(keyword.toLowerCase())
      );

      setSearchedResult(results);
    } else {
      setSearchedResult("");
      // If the text field is empty, show previous value
    }
    setQuery(keyword);
    setIsLoading(false);
  };

  const addToCurrentAndRecentStation = (info) => {
    let currentData = {
      id: info.stationuuid,
      name: info.name,
      country: info.country,
      icon: info.favicon,
      Frequency: info.bitrate,
      stream: info.url,
      tags: info.tags,
      language: info.language,
      codec: info.codec,
      state: info.state,
      homepage: info.homepage,
      votes: info.votes,
      clickcount: info.clickcount,
      worldradiostation: "yes",
    };

    return currentData;
  };

  //=========== display radio card ============
  const displaycard =
    countryformation && Object.keys(countryformation).length
      ? countryformation?.slice(0, paginate).map((info, index) => {
          if (!imageRefs.current[index]) {
            imageRefs.current[index] = React.createRef();
          }
          return (
            <Link
              key={info.stationuuid}
              href="/radio/[radioid]"
              as={`/radio/${info.stationuuid}`}
              onClick={() => {
                setCurrentStation(addToCurrentAndRecentStation(info));
                addToRecentStions(addToCurrentAndRecentStation(info));
              }}
            >
              <div className="world-radio__card">
                <div
                  className="world-radio__image"
                  style={{ width: "51px", height: "51px", aspectRatio: "1/1" }}
                >
                  <LazyLoadImage
                    ref={imageRefs.current[index]}
                    src={info?.favicon}
                    alt="logo"
                    placeholder={vinyl.src}
                    fallback={vinyl.src}
                    width="51px"
                    height="51px"
                  />
                </div>

                <div className="world-radio__info">
                  <p className="world-radio__info-title">{info?.name}</p>
                  {info?.votes ? (
                    <div style={{ padding: "10px 0px 0px" }}>
                      <span>
                        <span>𖦤</span>{" "}
                        {Number(info?.votes).toLocaleString("en-US")}
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                <div
                  className="world-radio__card-active"
                  style={{
                    visibility:
                      info.stationuuid === currentStation?.id
                        ? "visible"
                        : "hidden",
                    opacity:
                      info.stationuuid === currentStation?.id ? "1" : "0",
                  }}
                  suppressHydrationWarning
                >
                  <FontAwesomeIcon icon={faPlay} />
                </div>
              </div>
            </Link>
          );
        })
      : "";

  //=== display card for searched results ===
  const searchedresultcard =
    searchedResult && Object.keys(searchedResult).length
      ? searchedResult?.slice(0, paginateQuery).map((info, index) => {
          if (!imageRefs.current[index]) {
            imageRefs.current[index] = React.createRef();
          }
          return (
            <Link
              key={info.stationuuid}
              href="/radio/[radioid]"
              as={`/radio/${info.stationuuid}`}
              onClick={() => {
                setCurrentStation(addToCurrentAndRecentStation(info));
                addToRecentStions(addToCurrentAndRecentStation(info));
              }}
            >
              <div
                className="world-radio__card"
                style={{ backgroundColor: "#f2f2f2" }}
              >
                <div
                  className="world-radio__image"
                  style={{ width: "51px", height: "51px", aspectRatio: "1/1" }}
                >
                  <LazyLoadImage
                    ref={imageRefs.current[index]}
                    src={info.favicon}
                    alt="logo"
                    placeholder={vinyl.src}
                    fallback={vinyl.src}
                    width="51px"
                    height="51px"
                  />
                </div>

                <div className="world-radio__info">
                  <p className="world-radio__info-title">{info?.name}</p>
                  {info?.votes ? (
                    <div style={{ padding: "10px 0px 0px" }}>
                      <span>
                        <span>𖦤</span>{" "}
                        {Number(info?.votes).toLocaleString("en-US")}
                      </span>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="world-radio__card-active"
                  style={{
                    display:
                      info.name === currentStation?.name ? "flex" : "none",
                  }}
                >
                  <FontAwesomeIcon icon={faPlay} />
                </div>
              </div>
            </Link>
          );
        })
      : "";

  //= Onclick function to move the div to the top =//
  function scrollToView() {
    divToView.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
  const moveToViewRef = useCallback((node) => {
    if (node !== null && node !== "") {
      setDivToView(node);
    }
  }, []);

  //= Intersection Observer function =
  const loadMoreDivRef = useCallback((node) => {
    if (node !== null) {
      setLoadMore(node);
    }
  }, []);
  const loadingObserver = useCallback((entries) => {
    if (entries[0].isIntersecting) {
      setPaginate((prevValue) => prevValue + 20);
    }
  }, []);
  useEffect(() => {
    const loadingObserverOptions = {
      root: document,
      rootMargin: "20px",
      threshold: 1.0,
    };
    const observer = new IntersectionObserver(
      loadingObserver,
      loadingObserverOptions
    );
    if (loadMore) {
      observer.observe(loadMore);
    }
    return () => {
      if (loadMore) {
        observer.unobserve(loadMore);
      }
    };
  }, [loadMore, loadingObserver]);
  //============== Intersection Observer ends =========

  useEffect(() => {
    if (countryname && countryformation) {
      setIsLoadingPage(false);
    }
  }, [countryname, countryformation]);

  return (
    <main className={styles.main}>
      <div
        style={{
          width: "100%",
        }}
      >
        {/* Search Hero section */}
        <div
          style={{
            width: "100%",
            position: "relative",
            backgroundColor: "rgba(23, 27, 57, 0.81)",
            minHeigh: "400px",
          }}
        >
          <div className={styles.grid} style={{ margin: "auto" }}>
            <div
              className="allradios-wrapper"
              style={{
                padding: "0px",
                ...(countryFlag && {
                  backgroundImage: `linear-gradient(rgba(23, 27, 57, 0.9), rgba(23, 27, 57, 0.9)), url(${countryFlag})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }),
              }}
            >
              <div className="weather-date world-radio__caption">
                {" "}
                <h2
                  className="world-radio__caption-text"
                  style={{ borderBottom: "none" }}
                >
                  Radio Stations in {countryname}
                  {countryformation?.length ? (
                    <span style={{ marginLeft: "16px", color: "chartreuse" }}>
                      📻{" "}
                      {Number(countryformation?.length).toLocaleString("en-US")}
                    </span>
                  ) : (
                    ""
                  )}
                </h2>
              </div>

              <div className="allradios-wrapper" style={{ padding: "0px" }}>
                {" "}
                <div
                  className="player-wrapper player-wrapper1"
                  style={{
                    margin: query ? "20px auto" : "30px auto 70px",
                  }}
                >
                  {/*Search bar */}
                  <div className="form-wrapper__worldradio" ref={moveToViewRef}>
                    <p
                      style={{
                        color: "#fff",
                        textAlign: "center",
                        zIndex: "1",
                        fontSize: "20px",
                        fontWeight: "bold",
                      }}
                    >
                      Search Through The List Below
                    </p>
                    <div
                      className="form form-country"
                      style={{ position: "relative" }}
                    >
                      <input
                        type="search"
                        value={query}
                        onChange={searchfilterforradiostaion}
                        onFocus={scrollToView}
                        className="search-input__country"
                        placeholder={
                          isLoadingPage
                            ? "Loading Data... Please wait"
                            : "by name, language or genre"
                        }
                        autoComplete="off"
                        style={{ width: "100%" }}
                        disabled={isLoadingPage}
                      />
                      {isLoadingPage && (
                        <div
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "10px",
                            transform: "translateY(-50%)",
                            color: "rgba(42, 9, 9, 0.83)",
                          }}
                        >
                          <FontAwesomeIcon icon={faSpinner} spin />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isLoadingPage ? (
          <LoadingDataPlaceHolder />
        ) : (
          <>
            <div className={styles.grid} style={{ margin: "auto" }}>
              <Head>
                <title>{`Radio Stations in ${countryname} | radiobruce.com`}</title>
                <meta
                  name="description"
                  content="listen to internet radio from around the world"
                />
                <meta
                  name="keywords"
                  content="listen to radio from ghana, listen to radio from around the world, radio ghana, ghana radio stations online, live radio ghana, live radio stream ghana, radiobruce, name, genre, location, radioBruce, radio bruce, radiobruce, alliance francaise de takoradi, alliance francaise"
                />
                <meta name="og:site_name" content="radiobruce.com" />
                <meta
                  name="og:url"
                  content={`https://www.radiobruce.com/station/country/${countryname}`}
                />
                <meta
                  name="og:title"
                  content={`Radio Station in ${countryname}`}
                />
                <meta
                  name="og:description"
                  content="listen to internet radio from around the world."
                />
                <meta name="og:type" content="website" />
                <link rel="icon" href="/favicon.ico" />
              </Head>{" "}
              {query && (
                <div className="weather-date world-radio__caption">
                  <h2
                    style={{
                      textAlign: "left",
                      padding: "10px",
                      margin: "0px",
                      textTransform: "initial",
                      borderBottom: "none",
                    }}
                  >
                    {query === "undefined" ||
                    (query === "" && !searchedResult?.length) ? (
                      ""
                    ) : query !== "undefined" &&
                      query !== "" &&
                      !searchedResult?.length ? (
                      <span style={{ fontSize: "16px", color: "maroon" }}>
                        Your search for ***{" "}
                        <span
                          style={{
                            textTransform: "initial",
                          }}
                        >
                          {query}
                        </span>{" "}
                        *** cannot be found.
                      </span>
                    ) : (
                      <span style={{ fontSize: "16px" }}>
                        {searchedResult?.length} match found for ***{" "}
                        <span
                          style={{
                            textTransform: "initial",
                          }}
                        >
                          {query}
                        </span>{" "}
                        ***
                      </span>
                    )}
                  </h2>
                </div>
              )}
              <div
                className="allradios-wrapper"
                style={{ padding: "0px", background: "#fff" }}
              >
                {query === "undefined" || query === "" ? (
                  <div className="streams-container__wrapper streams-container__wrapper1">
                    <div className="world-radio__wrapper">{displaycard}</div>
                  </div>
                ) : (
                  <div className="streams-container__wrapper streams-container__wrapper1">
                    <div className="world-radio__wrapper">
                      {searchedresultcard}
                    </div>
                  </div>
                )}
                <div style={{ width: "100%", textAlign: "center" }}>
                  {paginate > countryformation?.length ? (
                    ""
                  ) : (
                    <div className="world-radio__wrapper" ref={loadMoreDivRef}>
                      {" "}
                      {loading && loadingText}
                    </div>
                  )}
                </div>
                {/* display show more button when there is query*/}
                {query && (
                  <button
                    className="button-loadmore"
                    style={{
                      display:
                        paginateQuery >= searchedResult?.length
                          ? "none"
                          : "block",
                    }}
                    onClick={() =>
                      setPaginateQuery((prevValue) => prevValue + 20)
                    }
                  >
                    Load More Stations{" "}
                    <span className="page-number__count">
                      {" "}
                      <span>{paginateQuery}</span> <span>of</span>{" "}
                      <span>{searchedResult?.length}</span>
                    </span>
                  </button>
                )}
              </div>
            </div>
            <Footer />
          </>
        )}
      </div>
    </main>
  );
};

export default StationByCountryName;

export const getStaticPaths = async () => {
  try {
    // Directly call the function to fetch the country list
    const countryListForOtherStations = await getCountryListForOtherStations1();

    // Validate the data and ensure we have an array
    if (!Array.isArray(countryListForOtherStations)) {
      console.warn("Invalid country list data:", countryListForOtherStations);
      return {
        paths: [],
        fallback: true,
      };
    }

    // Filter out any invalid entries and ensure name is a string
    const paths = countryListForOtherStations
      .filter((country) => country && typeof country.name === "string")
      .map(({ name }) => ({
        params: {
          countryname: name.toString(),
        },
      }));

    return {
      paths,
      fallback: true,
    };
  } catch (error) {
    console.warn("Error fetching country list:", error);
    return {
      paths: [],
      fallback: true,
    };
  }
};

export async function getStaticProps({ params }) {
  const pagename = params.countryname;
  // Directly call the function to fetch the country list
  const allcountrylistinalphabeticalorderwithiso =
    await getCountryListInAlphabeticalOrderWithIso1();

  const removeHyphenateTitle = (title) => {
    if (title) {
      return title.replaceAll(/[-]/g, (value) => ({ "-": " " }[value]));
    }
  };

  const filePath = path.join(
    process.cwd(),
    "public/stations__compressed__selectedfew.json.gz"
  );

  if (!fs.existsSync(filePath)) {
    return { notFound: true };
  }

  try {
    // Use streaming approach for reading and decompressing
    const readStream = fs.createReadStream(filePath);
    const gunzip = zlib.createGunzip();

    const chunks = [];
    for await (const chunk of readStream.pipe(gunzip)) {
      chunks.push(chunk);
    }

    const stations = JSON.parse(Buffer.concat(chunks).toString());

    // Filter stations based on the country name
    const countryname = removeHyphenateTitle(params?.countryname).toLowerCase();
    const countryformation = stations?.filter(
      ({ country }) =>
        country && country?.toLowerCase() === countryname?.toLowerCase()
    );

    if (countryformation.length === 0) {
      console.error(`No stations found for country: ${countryname}`);
      return {
        notFound: true,
      };
    }

    //== remove duplicates
    const removeDuplicates =
      countryformation && Object.keys(countryformation).length
        ? Array.from(
            new Map(
              countryformation?.map((item) => [
                `${item.stationuuid}-${item.name}`,
                item,
              ])
            ).values()
          )
        : "";

    const getCountryFlag1 = (
      pagename,
      allcountrylistinalphabeticalorderwithiso
    ) => {
      if (!Array.isArray(allcountrylistinalphabeticalorderwithiso)) return "";
      const normalizedPagename = removeHyphenateTitle(pagename)?.toLowerCase();
      // Look through each region
      for (const region of allcountrylistinalphabeticalorderwithiso) {
        // Look through countries in each region's sub array
        if (Array.isArray(region.sub)) {
          const matchingCountry = region.sub.filter(
            (country) => country?.country?.toLowerCase() === normalizedPagename
          )[0];

          if (matchingCountry) {
            return matchingCountry.flagUrl || "";
          }
        }
      }
      return "";
    };
    const countryFlag = getCountryFlag1(
      pagename,
      allcountrylistinalphabeticalorderwithiso
    );

    return {
      props: {
        countryname: removeHyphenateTitle(pagename),
        countryformation: removeDuplicates || null,
        countryFlag: countryFlag,
      },
      revalidate: 86400, // Revalidate every 24 hours
    };
  } catch (error) {
    console.error("Error processing stations file:", error);
    return {
      notFound: true,
    };
  }
}

const loadingText = (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <h3>
      Loading{" "}
      <FontAwesomeIcon
        icon={faSpinner}
        style={{ animation: "spin 2s linear infinite" }}
      />
    </h3>
  </div>
);
